export const ALERT_SUGGESTED_QUERIES = [
    'a person with green shirt touches the door',
    'a person wearing a hat enters the building',
    'someone places a package in the lobby',
];

export const ALERT_PROMPT_PREFIX = 'Notify me when you see';

export const ALERT_DEFAULT_CONFIDENCE_THRESHOLD = 70;
